module.exports = __webpack_public_path__ + "img/BG_Kopilote_Desktop.0e152a5c.svg";